// components/layout/Navbar/index.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "../../../hooks/useAuth";
import { authService } from "../../../services/auth.service";
import { Button } from "../../../styles/components";
import {
	NavWrapper,
	NavContainer,
	Logo,
	NavLinks,
	NavLink,
	MobileMenuButton,
	MobileMenu,
	MobileNavLink,
	MobileMenuContent,
	MobileLogo,
} from "./styles";
import { useNavbar } from "../../../hooks/useNavbar";

const Navbar = () => {
	const { isTransparent } = useNavbar();
	const navigate = useNavigate();
	const { user } = useAuth();
	const [isScrolled, setIsScrolled] = useState(false);
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setIsScrolled(window.scrollY > 20);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	useEffect(() => {
		if (isMobileMenuOpen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "unset";
		}

		return () => {
			document.body.style.overflow = "unset";
		};
	}, [isMobileMenuOpen]);

	const handleNavigation = (path) => {
		setIsMobileMenuOpen(false);
		navigate(path);
	};

	const handleLogout = async () => {
		try {
			await authService.logout();
			setIsMobileMenuOpen(false);
			navigate("/login");
		} catch (error) {
			console.error("Logout failed:", error);
		}
	};

	return (
		<NavWrapper isScrolled={isScrolled} isTransparent={isTransparent}>
			<NavContainer>
				<Logo
					to="/"
					onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
				>
					Le Petit
				</Logo>

				<NavLinks>
					{user ? (
						<>
							<NavLink to="/dashboard">Profile</NavLink>
							<NavLink to="/gallery">Gallery</NavLink>
							{user.role === "admin" && <NavLink to="/admin">Admin</NavLink>}
							<Button variant="outlined" onClick={handleLogout}>
								Logout
							</Button>
						</>
					) : (
						<>
							<NavLink to="/pricing">Pricing</NavLink>
							<NavLink to="/about">About</NavLink>
							<NavLink to="/gallery">Gallery</NavLink>
							<Button
								variant="primary"
								onClick={() => handleNavigation("/login")}
							>
								Login
							</Button>
						</>
					)}
				</NavLinks>

				<MobileMenuButton
					variant="text"
					onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
				>
					{isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
				</MobileMenuButton>
			</NavContainer>

			<MobileMenu isOpen={isMobileMenuOpen}>
				<MobileMenuContent>
					<MobileLogo to="/" onClick={() => setIsMobileMenuOpen(false)}>
						Le Petit
					</MobileLogo>

					{user ? (
						<>
							<MobileNavLink
								to="/dashboard"
								onClick={() => handleNavigation("/dashboard")}
							>
								Dashboard
							</MobileNavLink>
							<MobileNavLink
								to="/gallery"
								onClick={() => handleNavigation("/gallery")}
							>
								Gallery
							</MobileNavLink>
							{user.role === "admin" && (
								<MobileNavLink
									to="/admin"
									onClick={() => handleNavigation("/admin")}
								>
									Admin
								</MobileNavLink>
							)}
							<Button size="large" variant="outlined" onClick={handleLogout}>
								Logout
							</Button>
						</>
					) : (
						<>
							<MobileNavLink
								to="/pricing"
								onClick={() => handleNavigation("/pricing")}
							>
								Pricing
							</MobileNavLink>
							<MobileNavLink
								to="/about"
								onClick={() => handleNavigation("/about")}
							>
								About
							</MobileNavLink>
							<MobileNavLink
								to="/gallery"
								onClick={() => handleNavigation("/gallery")}
							>
								Gallery
							</MobileNavLink>
							<Button size="large" onClick={() => handleNavigation("/login")}>
								Login
							</Button>
						</>
					)}
				</MobileMenuContent>
			</MobileMenu>
		</NavWrapper>
	);
};

export default Navbar;
